import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useLingui } from '@lingui/react'
import { Trans, msg } from '@lingui/macro'
import {
  Alert
  , Box
  , Button
  , Container
  , Grid
  , IconButton
  , InputAdornment
  , LinearProgress
  , Link
  , TextField,
  Typography
} from '@mui/material/'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'

import Copyright from '../components/Copyright'
import useHttp from '../hooks/useHttp'
import { interpolateOrgs } from '../utils'
import { LanguageSwitcher } from '../components/LanguageSwitcher'
import SvgCustomIcon from "../components/icons/SvgCustomIcon";
import {Snackbar, useTheme} from "@mui/material";

// eslint-disable-next-line no-restricted-globals
const loginUrl = new URL('api/login',location)
// eslint-disable-next-line no-restricted-globals
const initUrl = new URL('/api/init', location)

const flag = `url('assets/${process.env.REACT_APP_FLAG}')`
const containerImage = `url('assets/Sfondo_ADaMS_NEW_version.jpg')`

export default function Login({ isMobile, setThemeMode }) {
  const navigate = useNavigate()
  const [token, setToken] = useState(null)
  const [showPassword, setShowPassword] = useState(false)
  const [lastLoginDate, setLastLoginDate] = useState(null)

  const handleClickShowPassword = () => setShowPassword(show => !show)


  const { isLoading, error, sendRequest, reset } = useHttp()
  const [username,setUsername] = useState(null)
  const [password,setPassword] = useState(null)
    const theme = useTheme()

  const { _ } = useLingui()

  const handleSubmit = () => {
    // event.preventDefault()
    //const data = new FormData(event.currentTarget)

    //const username = data.get('username')
    // const password = data.get('password')

    console.log('username ',username)
    const authdata = window.btoa(`${username}:${password}`)


    const addDaysToToday = (days) => {
      const date = new Date()
      date.setDate(date.getDate() + days)
      return date
    }

    sendRequest({
      url: loginUrl
      , httpMethod: 'POST'
      , httpHeaders: { Authorization: `Basic ${authdata}` }
      , manageResData: res => {
        console.log('res handle submit login --> ', res)
        setToken(res.token)
        const timestamp = addDaysToToday(10).getTime()
        console.log('timestamp -- ', timestamp)
        const user = { timestamp }
        localStorage.setItem('adams_user', JSON.stringify(user))
        setLastLoginDate(res.last_login_date)
      }
    })
  }

  const getInit = useCallback(async () => {
    sendRequest({
      token
      , url: initUrl
      , manageResData: res => {
        console.log('INIT', res)
        // eslint-disable-next-line camelcase
        let { error: initError, error_code, result, organizations, ...init } = res // { configuration, defaults, user, totalCrashes }
        init = { ...init, organizations: interpolateOrgs(organizations) }
        const user = init.user
        setThemeMode(user.theme)
        let adamsUser = JSON.parse(localStorage.getItem('adams_user'))
        adamsUser = { ...adamsUser, ...user, lastLoginDate, init, token }
        // adamsUser.init = init
        // adamsUser.count = count
        // adamsUser.token = token
        // Object.assign(adamsUser,user)
        localStorage.removeItem('adams_user')
        localStorage.setItem('adams_user', JSON.stringify(adamsUser))
        navigate('/home', { state: { token, init, lastLoginDate } })
      }
    })
  }, [token, lastLoginDate, sendRequest, navigate, setThemeMode])

  useEffect(() => {
    const adamsUser = JSON.parse(localStorage.getItem('adams_user'))
    if (adamsUser) {
      const timestampNow = new Date().getTime()
      if (timestampNow < adamsUser.timestamp) {
        navigate('/home', {
          state: {
            token: adamsUser.token
            , init: adamsUser.init
            , lastLoginDate: adamsUser.lastLoginDate
          }
        })
      }
    } else {
      localStorage.removeItem('adams_user')
    }
  }, [navigate])

  useEffect(() => {
    if (token && lastLoginDate) getInit()
  }, [token, lastLoginDate, getInit])

  const typographySectionStyle = { textAlign: 'center', color: 'white', padding: 4, fontSize: 24, fontWeight: 700 }

    return (
        <Box
            sx={{
                backgroundImage: `${containerImage}`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                px: 2,
                position: 'relative',
            }}
        >
            <LanguageSwitcher/>

            {/* Logo
            <Container maxWidth='xs' sx={{mb: 2}}>
  <img
                    src="../assets/adams_logo_black_senza_payoff.png"
                    style={{
                        height: isMobile ? 60 : 80,
                        width: '100%',
                        objectFit: 'contain',
                    }}
                    alt="ADaMS Logo"
                />
            </Container>
             */}

            {/* Main Card */}
            <Container
                maxWidth="xs"
                sx={{
                    width: '100%',
                    backgroundColor: 'white',
                    boxShadow: '-8px 0px 20px rgba(0, 0, 0, 0.2)',
                    borderRadius: 10,
                    py: 3,
                    px: 3,
                }}
            >
                <Box sx={{p:2}}>
                    <img
                        src="../assets/adams_logo_black_senza_payoff.png"
                        style={{
                            height: isMobile ? 60 : 80,
                            width: '100%',
                            objectFit: 'contain',
                        }}
                        alt="ADaMS Logo"
                    />
                </Box>
                <Box>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="username"
                        sx={{
                            background: '#EDEDED',
                            borderRadius:4,
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    border: 'none'
                                },
                                '&:hover fieldset': {
                                    border: 'none'
                                },
                                '&.Mui-focused fieldset': {
                                    border: 'none'
                                },
                            }}}
                        label={_(msg`Username`)}
                        name="username"
                        autoComplete="off"
                        autoFocus
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label={_(msg`Password`)}
                        sx={{
                            background: '#EDEDED',
                            borderRadius:4,
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    border: 'none',
                                },
                                '&:hover fieldset': {
                                    border: 'none',
                                },
                                '&.Mui-focused fieldset': {
                                    border: 'none',
                                },
                            }}}
                        type={showPassword ? 'text' : 'password'}
                        id="password"
                        autoComplete="off"
                        onChange={(e) => setPassword(e.target.value)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff/> : <SvgCustomIcon  name={'visibility'} color={theme.palette.newColors.gray}/>}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>

                <Grid container spacing={2} sx={{mt: 2}}>
                    <Grid item xs={12}>
                        <Button
                            onClick={handleSubmit}
                            fullWidth
                            variant="contained"
                            disabled={isLoading}
                            sx={{
                                color: 'white',
                                background: theme.palette.newColors.pinkGradient,
                                borderRadius: '12px',
                                py: 1.5,
                                transition: 'all 0.2s ease-in-out',
                                '&:hover': {
                                    background: theme.palette.newColors.pinkGradient,
                                    transform: 'scale(1.03)',
                                },
                                '&:disabled': {
                                    background: 'lightgray',
                                    color: '#666',
                                    cursor: 'not-allowed',
                                },
                            }}
                        >
                            {isLoading ? (
                                <Trans>Accesso in corso...</Trans>
                            ) : (
                                <Trans>LOGIN</Trans>
                            )}
                        </Button>
                    </Grid>

                    <Grid item xs={12} sx={{ textAlign: 'center' }}>
                        <Typography
                            variant="body2"
                            sx={{
                                fontSize: isMobile ? 16 : 14,
                                color: 'black',
                            }}
                        >
                            <Trans>Forgot</Trans>{' '}
                            <Link
                                href="/forgot-pwd"
                                sx={{
                                    color: theme.palette.newColors.pink,
                                    textDecoration: 'none',
                                    fontWeight: 600,
                                    '&:hover': { textDecoration: 'underline' },
                                }}
                            >
                                <Trans>password?</Trans>
                            </Link>
                        </Typography>
                    </Grid>

                    <Grid item xs={12} sx={{ textAlign: 'center' }}>
                        <Typography
                            variant="body2"
                            sx={{
                                fontSize: isMobile ? 16 : 14,
                                color: 'black',
                            }}
                        >
                            <Trans>Don’t have an account?</Trans>{' '}
                            <Link
                                href="/signup"
                                sx={{
                                    color: theme.palette.newColors.pink,
                                    textDecoration: 'none',
                                    fontWeight: 600,
                                    '&:hover': { textDecoration: 'underline' },
                                }}
                            >
                            <Trans>Sign Up</Trans>
                            </Link>
                        </Typography>
                    </Grid>
                </Grid>

                <Grid
                    container
                    spacing={2}
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                        mt: 1, // ridotto (prima era 3)
                        mb: 1,
                    }}
                >
                    <Grid
                        item
                        xs={6}
                        sm={4}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <Box
                            component="img"
                            src="../assets/Flag_of_Guinea.png"
                            alt="Guinea Flag"
                            sx={{
                                width: '100%',
                                maxWidth: 100,
                                objectFit: 'contain',
                            }}
                        />
                    </Grid>

                    <Grid
                        item
                        xs={6}
                        sm={4}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <Box
                            component="img"
                            src="../assets/Coat_of_Arms_of_Guinea.png"
                            alt="Guinea Seal"
                            sx={{
                                width: '100%',
                                maxWidth: 80, // più piccola
                                objectFit: 'contain',
                            }}
                        />
                    </Grid>
                </Grid>
            </Container>

            {/* Footer */}
            <Box
                component="a"
                href="https://www.fredeng.eu/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                    position: 'absolute',
                    bottom: 16,
                    right: 16,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    px: 2,
                    py: 1,
                    borderRadius: 2,
                    textDecoration: 'none',
                }}
            >
                <Typography variant="body2" sx={{color: 'white'}}>Powered by</Typography>
                <Box component="img" src="../assets/logo_fred_senza_payoff_2.png" alt="Fred logo"
                     sx={{height: isMobile ? 64 : 96}}/>
            </Box>


        </Box>
    )
}
